<template>
<el-container>
  <el-main>
  <!-- 添加房间 -->
  <el-dialog
    :title="addRoomForm.title"
    :modal-append-to-body="false"
    :lock-scroll="false"
    :visible.sync="addRoomVisible"
    width="400px"
  >
  <el-form
      :inline="true"
      :model="addRoomForm"
      ref="addRoomForm"
      class="demo-ruleForm"
  >
  <el-form-item label-width="120px" :label="$t('roomList.buildingName')">
        <el-select clearable :disabled="addRoomForm.isEdit" v-model="addRoomForm.buildingId" @change="addBuildingSelectChange" style='width:200px' :placeholder="$t('roomList.choose')">
          <el-option
           v-for="item in addBuildingOptions"
           :key="item.buildingId"
           :label="item.buildingName"
           :value="item.buildingId">
          </el-option>
        </el-select>
  </el-form-item>
   
  <el-form-item label-width="120px" :label="$t('roomList.floorName')">
    <el-select clearable :disabled="addRoomForm.isEdit" v-model="addRoomForm.floorId" :placeholder="$t('roomList.choose')" style='width:200px'>
      <el-option
        v-for="item in addFloorOptions"
        :key="item.floorId"
        :label="item.floorName"
        :value="item.floorId">
      </el-option>
    </el-select>
  </el-form-item>

  <el-form-item label-width="120px" :label="$t('roomList.roomName')">
    <el-input v-model="addRoomForm.roomName" :placeholder="$t('roomList.inputRoomName')" style='width:200px'></el-input>
  </el-form-item>

  <!-- <el-form-item label-width="100px" label="入住人数">
    <el-input-number v-model="addRoomForm.authorizeNumber" :min="1" :max="100" label="请输入住数量"></el-input-number>
  </el-form-item> -->
   
  <div style="margin-top: 10px">
    <el-button type="primary" @click="confirmAddRoom">{{$t("apartmentRoomDetail.confirm")}}</el-button>
    <el-button type="primary" @click="addRoomVisible = false;">{{ $t("apartmentRoomDetail.cancel") }}</el-button>
  </div>

  </el-form>  
  </el-dialog>
  <el-form :inline="true" class="demo-form-inline">
     <el-form-item :label="$t('roomList.apartment')">
        <el-select v-model="selectForm.apartmentId" filterable @change="apartmentSelectChange" :placeholder="$t('roomList.choose')">
          <el-option
           v-for="item in apartmentOptions"
           :key="item.apartmentId"
           :label="item.apartmentName"
           :value="item.apartmentId">
          </el-option>
        </el-select>
      </el-form-item>
     
      <el-form-item :label="$t('roomList.buildingName')">
        <el-select v-model="selectForm.buildingId" @change="buildingSelectChange" :placeholder="$t('roomList.choose')">
          <el-option
           v-for="item in buildingOptions"
           :key="item.buildingId"
           :label="item.buildingName"
           :value="item.buildingId">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item :label="$t('roomList.floorName')">
        <el-select clearable v-model="selectForm.floorId" :placeholder="$t('roomList.choose')">
          <el-option
           v-for="item in floorOptions"
           :key="item.floorId"
           :label="item.floorName"
           :value="item.floorId">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item :label="$t('roomList.roomNo')">
         <el-input v-model="selectForm.roomName" prefix-icon="el-icon-search" style="width:180px" :placeholder="$t('roomList.inputRoomNo')"></el-input>
      </el-form-item>
     <el-form-item :label="$t('roomList.ifBind')">
        <el-select clearable v-model="selectForm.isBind" :placeholder="$t('roomList.choose')" style="width:100px">
          <el-option
           v-for="item in isBindOptions"
           :key="item.value"
           :label="item.lable"
           :value="item.value">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item >
        <el-button type="primary"  icon="el-icon-search" @click="onSelectRoomList">{{$t('roomList.search')}}</el-button>
        <el-button type="primary" icon="el-icon-plus" @click="addRoom">{{$t('roomList.addRoom')}}</el-button>
      </el-form-item>
  </el-form>
 
  <el-table
    :data="pageData.roomData"
    :header-cell-style="{ background: '#eef1f6', color: '#606266' }"
    empty-text="No Data"
    border
    style="margin-top: 5px"
   >
    <el-table-column
    prop="apartmentName"
    :label="$t('roomList.apartmentName')">
    </el-table-column>

    <el-table-column
    prop="buildingName"
    :label="$t('roomList.buildingName')">
    </el-table-column>

    <el-table-column
    prop="floorName"
    :label="$t('roomList.floorName')">
    </el-table-column>

    <el-table-column
    prop="roomName"
    :label="$t('roomList.roomName')">
    </el-table-column>

    <!-- <el-table-column
    prop="authorizeNumber"
    :label="$t('roomList.guestNumber')">
    </el-table-column> -->

    <el-table-column
    prop="bindDevice"
    :label="$t('roomList.ifBind')">
      <template slot-scope="scope">
        {{scope.row.bindDevice==0?$t('roomList.noBind'):scope.row.bindDevice==1?$t('roomList.isBind'):""}}
      </template>
    </el-table-column>
     
   <el-table-column
      prop
      :label="$t('roomList.operate')"
      width="300"
      align="center"
    >
      <template slot-scope="scope">
         <el-button
          type="primary"
          size="mini"
          style="margin-top:5px"
          @click="roomDetai(scope.$index, scope.row)"
      >{{$t('roomList.details')}}</el-button>

         <el-button
          type="primary"
          size="mini"
          style="margin-top:5px"
          @click="authorization(scope.$index, scope.row)"
      >{{$t('tenant.checkIn')}}</el-button>
        
         <el-button
          type="primary"
          size="mini"
          style="margin-top:5px"
          @click="editRoom(scope.$index, scope.row)"
        >{{$t('roomList.edit')}}</el-button>

        <el-button
          type="danger"
          size="mini"
          style="margin-top:5px"
          @click="deleteRoom(scope.$index, scope.row)"
        >{{$t('roomList.delete')}}</el-button>
      </template>
    </el-table-column>

    </el-table>

    <el-footer>
      <div>
        <Pagings
        :total="pageData.total"
        :offset="pageData.offset"
        :pageSize="pageData.pageNumber"
        @handleSizeChangeSub="roomHandleSizeChange"
        @handleCurrentChangeSub="roomHandleCurrentChange">
        </Pagings>
      </div>
    </el-footer> 
  </el-main>
</el-container>      
</template>

<script>
import Pagings from "../common/Pagings.vue";
export default {
  name: "schoolList",
  data() {
     return {
        pageData:{
         offset: 1,
         pageNumber: 10,
         total: 0, //总条数
         roomData: [],
        },
        selectForm:{
          apartmetnId:"",
          buildingId:"",
          floorId:"",
          roomId:"",
          roomName:this.$route.query.roomName==undefined?"":this.$route.query.roomName,
          isBind:"",
        },
        apartmentOptions:[],
        buildingOptions:[],
        floorOptions:[],
        addBuildingOptions:[],
        addFloorOptions:[],
        isBindOptions:[
           {
            value:'',
            lable:this.$t('tenant.all')
          },
          {
            value:0,
            lable:this.$t('roomList.noBind')
          },
          {
            value:1,
            lable:this.$t('roomList.isBind')
          }
        ],
        addRoomVisible:false,
        addRoomForm:{
          buildingId:"",
          floorId:"",
          roomName:"",
          isEdit:false,
          title:"",
          // authorizeNumber:4
        }
     }      
  },
  components: {
    Pagings
  },
  mounted() {
    this.getApartmentList();
    // this.getBuildingList();
    // this.roomPower();
  }, 
  methods: {
    //查看房间详情
    roomDetai(index,row){
      if(row.deviceId!=""&&row.deviceId!=null){
         this.$router.push({path: "/roomDetail",query: {deviceId:row.deviceId,roomId:row.roomId,apartmentId:this.selectForm.apartmentId}});
      }else{
        this.$message({
          message:this.$t('roomList.roomNoBindDevice'),
          type: "warning"
        });
      }
     
    },
    //授权房间
    authorization(index,row){
      this.$router.push({path: "/checkInMoreRoom",query: {roomId:row.roomId,apartmentId:this.selectForm.apartmentId,checkIn:row.checkIn}});
    },
     //编辑房间
    editRoom(index,row){
      this.addRoomForm.buildingId=row.buildingId;
      this.getAddFloorList();
      this.addRoomForm.floorId=row.floorId;
      this.addRoomForm.roomName=row.roomName;
      this.addRoomForm.roomId=row.roomId;
      this.addRoomVisible=true;
      this.addRoomForm.isEdit=true;
      this.addRoomForm.title=this.$t('roomList.editRoom')
    },
    //删除房间
    deleteRoom(index,row){
        this.$confirm(this.$t('roomList.confirmDelRoom'),this.$t("tenant.hint"), {
          confirmButtonText: this.$t("tenant.confirm"),
          cancelButtonText: this.$t("tenant.cancel"),
          type: 'warning'
        }).then(() => {
             var formData = new FormData();
             formData.append("roomId ",row.roomId);
             this.$server
             .exam("/customer/apartment/deleteRoom", formData)
            .then(data => {
              if (data.code == 200) {
                this.roomPower();
                this.$message({
                 message:this.$t('roomList.deleteSuccess'),
                 type: "success"
                });
              } else {
                this.$message({
                 message: data.message,
                 type: "warning"
                });
              }
            });
        }).catch(() => {
          this.$message({
            type: 'info',
            message: this.$t("tenant.cancelDelete")
          });          
        });  
    },
    //添加页面楼栋选择切换
    addBuildingSelectChange(){
      if(this.addRoomForm.buildingId==""||this.addRoomForm.buildingId==null){
         this.addFloorOptions=[];
         this.addRoomForm.floorId="";
      }else{
         this.getAddFloorList();
      }
    },
    //确定添加房间
    confirmAddRoom(){
       var buildingId=this.addRoomForm.buildingId;
       var floorId=this.addRoomForm.floorId;
       var roomName=this.addRoomForm.roomName;
       if(floorId==""||floorId==null){
          this.$message({
            message: this.$t("roomList.chooseFloor"),
            type: "warning"
          });
           return false;
       }
       if(roomName==""||roomName==null){
          this.$message({
            message:  this.$t("roomList.chooseFloor"),
            type: "warning"
          });
           return false;
       }
      if(!this.addRoomForm.isEdit){
        var formData = new FormData();
        formData.append("apartmentId ",this.selectForm.apartmentId);
        formData.append("floorId",floorId);
        formData.append("roomName",roomName);
        this.$server
        .exam("/customer/apartment/addApartmentRoom", formData)
        .then(data => {
          if (data.code == 200) {
           this.addRoomVisible=false;
           this.roomPower(); 
            this.$message({
             message: this.$t("roomList.addRoomSuccess"),
             type: "success"
            });
          } else {
           this.$message({
            message: data.message,
            type: "warning"
           });
          }
        });
      }else{

        var formData = new FormData();
        formData.append("roomId", this.addRoomForm.roomId);
        formData.append("roomName",roomName);
        this.$server
        .exam("/customer/apartment/editApartmentRoom", formData)
        .then(data => {
          if (data.code == 200) {
           this.addRoomVisible=false;
           this.roomPower(); 
            this.$message({
             message: this.$t("roomList.editRoomSuccess"),
             type: "success"
            });
          } else {
           this.$message({
            message: data.message,
            type: "warning"
           });
          }
        });
      }
     
    },
    //添加房间
    addRoom(){
      this.addRoomForm.buildingId="";
      this.addRoomForm.floorId="";
      this.addRoomForm.roomName="";
      this.addRoomForm.roomId="";
      this.addRoomVisible=true;
      this.addRoomForm.isEdit=false;//是否是编辑房间
      this.addRoomForm.title=this.$t("roomList.addRoom")
    },
    //搜索房间列表
    onSelectRoomList(){
      this.roomPower();
    },

    //公寓改变值事件
    apartmentSelectChange(){
         this.getBuildingList();
         this.floorOptions=[];
    },

    //楼栋下拉选择值改变事件
    buildingSelectChange(){
      if(this.selectForm.buildingId==""||this.selectForm.buildingId==null){
         this.floorOptions=[];
         this.selectForm.floorId="";
      }else{
        this.getFloorList();
      }
      
    },
   
    getFloorList(){
      var formData = new FormData();
      formData.append("apartmentId",this.selectForm.apartmentId);
      formData.append("buildingId",this.selectForm.buildingId);
      this.$server
      .exam("/customer/apartment/listBaseFloor", formData)
      .then(data => {
        if (data.code == 200) {
          this.floorOptions=data.data;    
          this.addFloorOptions=data.data;      
        } else {
          this.$message({
            message: data.message,
            type: "warning"
          });
        }
      });  
    },

     getAddFloorList(){
      var formData = new FormData();
      formData.append("apartmentId", this.selectForm.apartmentId);
      formData.append("buildingId",this.addRoomForm.buildingId);
      this.$server
      .exam("/customer/apartment/listBaseFloor", formData)
      .then(data => {
        if (data.code == 200) {
          this.addFloorOptions=data.data;      
        } else {
          this.$message({
            message: data.message,
            type: "warning"
          });
        }
      });  
    },

    getBuildingList(){
      var formData = new FormData();
      if(this.selectForm.apartmentId!=""&&this.selectForm.apartmentId!=null){
        formData.append("apartmentId", this.selectForm.apartmentId);
      }
      this.$server
      .exam("/customer/apartment/listBaseBuilding", formData)
      .then(data => {
        if (data.code == 200) {
          this.buildingOptions=data.data;
          this.addBuildingOptions=data.data;          
        } else {
          this.$message({
            message: data.message,
            type: "warning"
          });
        }
      });  
    },

    getApartmentList(){
      var formData = new FormData();
      this.$server
      .exam("/customer/apartment/listOwnerApartment", formData)
      .then(data => {
        if (data.code == 200) {
          this.apartmentOptions=data.data;
          if(data.data.length>0){
            if(this.$route.query.apartmentId!=undefined&&this.$route.query.apartmentId!=""&&this.$route.query.apartmentId!=null){
               this.selectForm.apartmentId=this.$route.query.apartmentId;
            }else{
               this.selectForm.apartmentId=data.data[0].apartmentId;
            }
            this.getBuildingList();
            this.roomPower();
          }
               
        } else {
          this.$message({
            message: data.message,
            type: "warning"
          });
        }
      });
    },
   
    roomPower(){
          var formData = new FormData();
          formData.append("apartmentId", this.selectForm.apartmentId);
          formData.append("pageNo", this.pageData.offset);
          formData.append("pageSize", this.pageData.pageNumber);
          
          var apartmentId=this.selectForm.apartmentId;
          var buildingId=this.selectForm.buildingId;
          var floorId=this.selectForm.floorId;
          var roomName=this.selectForm.roomName;
          var isBind=this.selectForm.isBind+'';
         
          if(buildingId!=""&&buildingId!=null){
             formData.append("buildingId",buildingId); 
          }
          if(floorId!=""&&floorId!=null){
             formData.append("floorId",floorId); 
          }
          if(roomName!=""&&roomName!=null){
             formData.append("roomName",roomName); 
          }
          
          if(isBind!="" && isBind!=null){
            formData.append("bindDevice",isBind); 
          }
          this.$server
          .exam("/customer/apartment/listRooms", formData)
          .then(data => {
           if (data.code == 200) {
             this.pageData.roomData = data.data.records;
             this.pageData.total = data.data.total;
            } else {
              this.$message({
               message: data.message,
               type: "warning"
              });
            }
         });
    },

     roomHandleSizeChange(val) {
       this.pageData.pageNumber = val;
       this.roomPower();
     },
     roomHandleCurrentChange(val) {
       this.pageData.offset = val;
       this.roomPower();
     },

  }    
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/components/room/roomList.vue